const BaseComponent = require('base/base-component');

class NewTag extends BaseComponent {
  init () {
    // add new tag - 当天发布加标记【new】
    const $pubTime = this.$el.find('.pub-time');
    $pubTime.each((_, el) => {
      let timeString = $(el).data('value');
      if (timeString.indexOf('CST') >= 0) {
        timeString = timeString.replace('CST', 'GMT+0800');
      }
      if (new Date().toDateString() === new Date(timeString).toDateString()) {
        // $(el).before($('<i class="iconfont icon-newchunse"></i>'));
         // 无标记时, 加上标记
        $(el).parent().has('.icon-newchunse')[0] ? 0 : $(el).before($('<i class="iconfont icon-newchunse"></i>'));
      }
    });
    // 暂无数据展示
    this.$listContainer = this.$el.find('.list-content');
    if (this.$listContainer.find('>li').length === 0) {
      this.$listContainer.append('<p class="noData">暂无数据</p>');
    }
  }
}

module.exports = NewTag;
